import { TYPES } from '../actions';

const initialState = {
  userGroups: [],
  loading: false,
  error: null
};

export const userGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_USER_GROUPS_LOADING:
    case TYPES.ACTION_SET_USER_GROUPS_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case TYPES.ACTION_GET_USER_GROUPS_SUCCESS:
      return {
        ...state,
        userGroups: action.payload.data?.groups || action.payload.data || [],
        loading: false,
        error: null
      };
    case TYPES.ACTION_SET_USER_GROUPS_SUCCESS:
      return {
        ...state,
        userGroups: action.payload.group,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_USER_GROUPS_FAIL:
    case TYPES.ACTION_SET_USER_GROUPS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}; 